function Badge({ theme, text }) {
  return (
    <span className={`badge bg-${theme}-soft`}>
      <small>{text}</small>
    </span>
  );
}

export default Badge;
